// Filter for normal archive page
if (!!document.getElementById("tietopankki-filters")) {
    //Gets query string
    const queryString = window.location.search;

    if (!!queryString) {
        if (queryString === "") {
            setActiveFilter("kaikki");
        } else {
            const urlParams = new URLSearchParams(queryString);
            for (const value of urlParams.values()) {
                setActiveFilter(value);
            }
        }
        /*
                const filterButtons = document.getElementsByClassName("filter-button");

                if (!!filterButtons) {
                    for (const button of filterButtons) {
                        const urlParams = new URLSearchParams(queryString);
                        let toggled = false;
                        for (const value of urlParams.values()) {
                            if (value === button.dataset.filter) {
                                toggled = true;
                            }
                        }

                        if (!toggled) {
                            button.href =
                                "?" + new URLSearchParams([["kategoria", button.dataset.filter]]).toString();
                        }



                        if (toggled) {
                          for (const value of urlParams.values()) {
                            if (value !== button.id) {
                              //newUrl.append("category[]", value);
                            }
                          }
                          //button.href = button.href + "?" + newUrl.toString();
                        } else {
                          //urlParams.append("category[]", button.id);
                          //button.href = button.href + "?" + urlParams.toString();
                        }

                    }
                }
                */
    } else {
        setActiveFilter("kaikki");
        /*
                const filterButtons = document.getElementsByClassName("filter-button");

                if (!!filterButtons) {
                    for (const button of filterButtons) {
                       button.href =
                            "?" + new URLSearchParams([["kategoria", button.dataset.filter]]).toString();
                    }
                }
        */
    }
}

function setActiveFilter(f) {
    const filter = document.querySelector('[data-filter="'+f+'"]');
    if (!!filter) {
        filter.classList.add("filtered");
    }
}